import { Badge, Button, ButtonGroup, useDisclosure } from '@chakra-ui/react';
import { AuditLog } from './types';
import { AuditLogDetailsModal } from './AuditLogDetailsModal';
import { formatInTimeZone } from 'date-fns-tz';

const AuditLogButtons = ({ data }: { data: AuditLog }) => {
  const modalHandler = useDisclosure();
  return (
    <>
      <ButtonGroup
        flexDir='row'
        justifyContent='flex-end'
        size='sm'
        width='full'
      >
        <Button
          variant='outline'
          aria-label='view audit logs details'
          size='sm'
          data-testid='view-details-audit-logs-button'
          onClick={() => modalHandler.onOpen()}
        >
          View Details
        </Button>
      </ButtonGroup>
      <AuditLogDetailsModal data={data} modalHandler={modalHandler} />
    </>
  );
};

export const tableOptions = {
  columns: [
    {
      id: 'actor',
      Header: 'Actor',
      accessor: ({ sourceSystemUserContext }: Partial<AuditLog>) =>
        sourceSystemUserContext?.id ||
        sourceSystemUserContext?.anonymousId || (
          <Badge colorScheme='neutral'>NOT SPECIFIED</Badge>
        ),
    },
    {
      id: 'action',
      Header: 'Action',
      accessor: ({ action }: Partial<AuditLog>) =>
        action ? (
          action.replace(/_/g, ' ')
        ) : (
          <Badge colorScheme='neutral'>NOT SPECIFIED</Badge>
        ),
    },
    {
      id: 'user',
      Header: 'User',
      accessor: ({ entity }: Partial<AuditLog>) =>
        entity?.id || <Badge colorScheme='neutral'>NOT SPECIFIED</Badge>,
    },
    {
      id: 'target',
      Header: 'Target',
      accessor: ({ extensions }: Partial<AuditLog>) => {
        const roles = extensions?.roles;
        const rolesArray = Array.isArray(roles) ? roles : [];
        return (
          rolesArray[0]?.scope || (
            <Badge colorScheme='neutral'>NOT SPECIFIED</Badge>
          )
        );
      },
    },
    {
      id: 'logTime',
      Header: 'Date',
      accessor: ({ time }: Partial<AuditLog>) => {
        if (!time) return 'Invalid Date';
        const dateOnly = formatInTimeZone(
          new Date(time).getTime(),
          'UTC',
          'MMM d, yyyy',
        );
        const timeOnly = formatInTimeZone(
          new Date(time).getTime(),
          'UTC',
          'h:mm a',
        );
        return (
          <>
            <span style={{ whiteSpace: 'nowrap' }}>{dateOnly}</span>
            <br />
            <span style={{ whiteSpace: 'nowrap' }}>{timeOnly} UTC</span>
          </>
        );
      },
      sortType: (rowA: any, rowB: any) => {
        const a = new Date(rowA.original.time).getTime();
        const b = new Date(rowB.original.time).getTime();
        return a - b;
      },
    },
    {
      id: 'audit-logs-table-buttons',
      Header: '',
      accessor: (data: AuditLog) => <AuditLogButtons data={data} />,
      disableSortBy: true,
    },
  ],
};

export const exportedForTesting = { AuditLogButtons };
